import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import "./button.scss";

// Button component
const Button = ({
  label = "Click Me",
  onClick = () => {},
  theme = "",
  size = "",
  variant = "primary",
  className = "",
  children = null,
  type = "button",
  id = "",
  disabled = false,
  title="",
  tooltipEnable=false
}) => {
  // Define button classes based on the theme, size, and variant
  let buttonClass;
  if (theme === "dark") {
    buttonClass = `btn-pool btn-pool-${variant}  btn-dark-dark`;
  } else if (theme === "light") {
    buttonClass = `btn-pool btn-pool-${variant}  btn-dark-light`;
  } else {
    buttonClass = `btn-pool btn-pool-${variant} `;
  }
  if (size) {
    buttonClass += ` btn-pool-${size}`;
  }
  if (className) {
    buttonClass += ` ${className}`;
  }

  const buttonRef = useRef(null);

  useEffect(() => {
    if (title && buttonRef.current) {
      const tooltip = new window.bootstrap.Tooltip(buttonRef.current);
      return () => tooltip.dispose(); // Cleanup on unmount
    }
  }, [title]);

  return (
    <div className={`button-wrapper ${
      size === 'md' ? `full-width` : ""
    }`}>
      <button
        ref={buttonRef}
        title={title}
        type={type}
        id={id}
        className={buttonClass}
        onClick={onClick}
        disabled={disabled}

        {...(tooltipEnable ? {
          "data-bs-toggle": "tooltip",
          "data-bs-placement": "top",
        } : {})}
      >
        {children ? children : label}
      </button>
    </div>
  );
};

// Prop types
Button.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string,
  theme: PropTypes.oneOf(["light", "dark"]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  variant: PropTypes.oneOf([
    "primary",
    "secondary",
    "success",
    "danger",
    "warning",
    "info",
    "light",
    "dark",
  ]),
};

export default Button;
